import React, { useState, useEffect } from 'react';
import OrderSummary from '../../Common/Ordersummary';

const PaymentOptionGoogle = ({ products = [], quantities = [], deliveryCharges = 0 }) => {
    const [selectedPayment, setSelectedPayment] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expiryMM, setExpiryMM] = useState('');
    const [expiryYY, setExpiryYY] = useState('');
    const [cvv, setCvv] = useState('');
    const [captcha, setCaptcha] = useState(generateCaptcha());
    const [captchaInput, setCaptchaInput] = useState('');
    const [totalAmount, setTotalAmount] = useState(0);
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        setTotalAmount(calculateTotal(products, quantities, deliveryCharges));
    }, [products, quantities, deliveryCharges]);


    
    function generateCaptcha() {
        return Math.random().toString(36).substring(2, 6).toUpperCase();
    }

    const handlePaymentSelection = (option) => {
        setSelectedPayment(option);
        if (option === 'Cash On Delivery') {
            setCaptcha(generateCaptcha());
        }
    };

    const handleConfirmOrder = () => {
        setShowPopup(true);
    };

    const refreshCaptcha = () => {
        setCaptcha(generateCaptcha());
    };

    const closePopup = () => {
        setShowPopup(false);
    };

    return (
        <div className="p-4 md:mt-60 mt-40">
        <div className="flex flex-col rounded-2xl md:flex-row gap-5 md:ml-28">
          <div className="md:w-2/3">
            <div className="shadow-md border border-gray-300 p-5 bg-white mb-5 rounded-2xl">
              <div className="flex justify-between items-center">
                <div>
                  <h1 className="font-bold text-2xl">DELIVERY ADDRESS</h1>
                  <br />

                <div className="flex flex-col">
                    {/* Google Pay UPI */}
                    <label className="flex items-center">
                        <input
                            type="radio"
                            name="payment"
                            value="Google Pay UPI"
                            checked={selectedPayment === 'Google Pay UPI'}
                            onChange={() => handlePaymentSelection('Google Pay UPI')}
                        />
                        <span className="ml-2 font-bold text-1xl">Google Pay UPI</span>
                    </label><br></br>
                    {selectedPayment === 'Google Pay UPI' && (
                        <div className="mt-2">
                            <input
                                type="text"
                                placeholder="Enter UPI ID"
                                className="block md:w-72 px-4 py-3 border border-gray-500 rounded-sm shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                            />
                            <button
                                className="mt-2 bg-[#FF0004] text-white py-2 px-4 rounded"
                                onClick={() => alert('Payment Successful!')}
                            >
                                Continue
                            </button>
                        </div>
                    )}

                    {/* Credit/Debit/ATM Card */}
                    <label className="flex items-center mt-4">
                        <input
                            type="radio"
                            name="payment"
                            value="Credit/Debit/ATM Card"
                            checked={selectedPayment === 'Credit/Debit/ATM Card'}
                            onChange={() => handlePaymentSelection('Credit/Debit/ATM Card')}
                        />
                        <span className="ml-2 font-bold text-1xl">Credit/Debit/ATM Card</span>
                    </label><br></br>
                    {selectedPayment === 'Credit/Debit/ATM Card' && (
                        <div className="mt-2">
                            <input
                                type="text"
                                placeholder="Enter Card Number"
                                value={cardNumber}
                                onChange={(e) => setCardNumber(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-1 mb-2 w-full"
                            />
                            <div className="flex space-x-2">
                                <input
                                    type="text"
                                    placeholder="MM"
                                    value={expiryMM}
                                    onChange={(e) => setExpiryMM(e.target.value)}
                                    className="border border-gray-300 rounded px-2 py-1 w-1/4"
                                />
                                <input
                                    type="text"
                                    placeholder="YY"
                                    value={expiryYY}
                                    onChange={(e) => setExpiryYY(e.target.value)}
                                    className="border border-gray-300 rounded px-2 py-1 w-1/4"
                                />
                                <input
                                    type="text"
                                    placeholder="CVV"
                                    value={cvv}
                                    onChange={(e) => setCvv(e.target.value)}
                                    className="border border-gray-300 rounded px-2 py-1 w-1/4"
                                />
                            </div>
                            <button
                                className="mt-2 bg-[#FF0004] text-white py-2 px-4 rounded"
                                onClick={() => alert('Payment Successful!')}
                            >
                                Pay
                            </button>
                        </div>
                    )}

                    {/* Cash On Delivery */}
                    <label className="flex items-center mt-4">
                        <input
                            type="radio"
                            name="payment"
                            value="Cash On Delivery"
                            checked={selectedPayment === 'Cash On Delivery'}
                            onChange={() => handlePaymentSelection('Cash On Delivery')}
                        />
                        <span className="ml-2 font-bold text-1xl">Cash On Delivery</span>
                    </label><br></br>
                    {selectedPayment === 'Cash On Delivery' && (
                        <div className="mt-2">
                            <p className="text-sm">Enter the characters below:</p>
                            <div className="flex items-center space-x-2">
                                <span className="font-bold text-lg border rounded-md p-2 shadow-md">{captcha}</span>
                                <input
                                    type="text"
                                    placeholder="Enter characters"
                                    value={captchaInput}
                                    onChange={(e) => setCaptchaInput(e.target.value)}
                                    className="border border-gray-300 rounded px-2 py-1"
                                />
                                <button
                                    className="bg-blue-300 text-white px-3 py-1 rounded shadow-md"
                                    onClick={refreshCaptcha}
                                >
                                    Refresh
                                </button>
                            </div>
                            <button
                                className="mt-2 bg-[#FF0004] text-white py-2 px-4 rounded"
                                onClick={handleConfirmOrder}
                            >
                                Confirm Order
                            </button>
                        </div>
                    )}
                </div>
            </div>
            </div>
            </div>
            </div>

            <OrderSummary products={products} quantities={quantities} deliveryCharges={deliveryCharges} />

            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white p-16 rounded shadow-lg text-left w-auto">
                        <h1 className="text-2xl font-bold mb-2">Thank you for your purchase!</h1>
                        <p>Your order will be processed within 24 hours during working days. <br />We will notify you by email once your order has been shipped.</p>
                        <br />
                        <a href="/">
                            <button
                                className="mt-4 bg-[#FF7835] text-white py-2 px-4 rounded"
                                onClick={closePopup}
                            >
                                Confirmed
                            </button>
                        </a>
                    </div>
                </div>
            )}
        </div>
        </div>
    );
};

const calculateTotal = (products, quantities, deliveryCharges) => {
    if (!Array.isArray(products) || !Array.isArray(quantities) || products.length === 0 || products.length !== quantities.length) {
        return deliveryCharges;
    }
    const productTotal = products.reduce((acc, product, index) => acc + (product.price * (quantities[index] || 0)), 0);
    return productTotal + deliveryCharges;
};

export default PaymentOptionGoogle;
